import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'lamp', 'Lamp', [["path",{"d":"M9 20h6"}],["path",{"d":"M12 20v-8"}],["path",{"d":"M5 12h14l-4 -8h-6l-4 8"}]]);